import React from 'react';
import {ReactComponent as Icon} from 'images/icon/trigger-clone.svg';

export default class extends React.PureComponent {
  render() {
    return <Icon className="icon clone" onClick={this.props.onClick} />;
  }
}
